import type { FreelancerWelcomePageLocales } from '../types';

const freelancerWelcomePageLocales: FreelancerWelcomePageLocales = {
  instructions1: `Great that you want to work as a freelancer in childcare via our platform Tadaah. In this application procedure you will learn everything about working via Tadaah, fill in your personal details and upload all the necessary documents step by step to be able to work as a freelancer in childcare.\n\n At every step, videos and instructions explain what is expected of you. \n\n We start with an introduction video about Tadaah`,
  instructions2: `The following video tells you more about the steps you have to go through before you can start freelancing through Tadaah.`,
  nextVideo: 'Next video',
  preferToReadInstructions: 'Prefer to read the instructions? Then ',
  start: 'Start registration procedure',
  title: 'Welcome',
  welcomeDialogInstructions: `
To be able to work as a freelancer in childcare, you must meet several requirements. 
In this application procedure we will take you step by step; what requirements there are and what documents you have to upload for this. Covered:
  \t•  Your personal and company information.
  \t•  Your registration with the Chamber of Commerce(KVK).
  \t•  Registration in the Childcare Register of Persons (PRK).
  \t•  Business liability insurance.
  \t•  Your obtained diplomas and certificates.

You will also answer some questions about Tadaah.

You will be guided through our application procedure.You will regularly receive an overview of your progress in the application procedure.
  `,
};

export default freelancerWelcomePageLocales;
